//Common
import * as ko from 'knockout';
import * as moment from 'moment';
import * as _ from 'underscore';
import $ from "jquery";

import {KanbanStore} from 'Core/Controls/Kanban/Stores/KanbanStore';
import {TagModel} from 'Core/Controls/Kanban/Models/TagModel';
import {
    ActionModel,
    CardThumbnailModel, ParentOrChildRecordModel,
    PriorityModel, RecordModel,
    ThumbnailModel,
    UserModel
} from 'Core/Controls/Kanban/Models/StatusModel';

import {FileModel} from 'Core/Controls/Image/Models/ImageDataModel';
import {ImageDataStore} from 'Core/Controls/Image/Stores/ImageDataStore';
import {ColorConverter} from "Core/Components/ColorSelector/ColorConverter";
import {UserTypes} from "User/UserManager";
import {ScreenTypes} from "Core/Common/Enums/ScreenTypes";
import {PathRunner} from "Core/Components/PathRunner/PathRunner";
import {Timer} from "Core/Controls/Timer/Timer";
import {TimerModel} from "Core/Controls/Timer/Models/TimerModel";

import {LABELS, NOTIFICATIONS} from 'Core/Components/Translation/Locales';

import {Notifier} from 'Core/Common/Notifier';
import {BlockUI} from 'Core/Common/BlockUi';
import {Tooltip} from "Core/Common/Tooltip";

//Templates
import Template from 'Core/Controls/Kanban/Templates/KanbanCard.html';
import DefaultParentOrChildRecordTemplate from 'Core/Controls/Kanban/Templates/Default/DefaultParentOrChildRecordTemplate.html';

import DesignCardNameTemplate from 'Core/Controls/Kanban/Templates/Default/DesignCardName.html';
import DesignCardInfoTemplate from 'Core/Controls/Kanban/Templates/Default/DesignCardInfo.html';
import DesignCardAliasTemplate from 'Core/Controls/Kanban/Templates/Default/DesignCardAlias.html';

import DefaultCardNameTemplate from 'Core/Controls/Kanban/Templates/Default/DefaultCardName.html';
import DefaultCardInfoTemplate from 'Core/Controls/Kanban/Templates/Default/DefaultCardInfo.html';
import DefaultCardAliasTemplate from 'Core/Controls/Kanban/Templates/Default/DefaultCardAlias.html';

import TodoCardNameTemplate from 'Core/Controls/Kanban/Templates/Todo/TodoCardName.html';
import TodoCardInfoTemplate from 'Core/Controls/Kanban/Templates/Todo/TodoCardInfo.html';
import TodoCardAliasTemplate from 'Core/Controls/Kanban/Templates/Todo/TodoCardAlias.html';

import TimerInCardTemplate from 'Core/Controls/Kanban/Templates/Default/TimerInCard.html';

ko.templates['Core/Controls/Kanban/Templates/KanbanCard'] = Template;

ko.templates['Core/Controls/Kanban/Templates/Default/DesignCardName'] = DesignCardNameTemplate;
ko.templates['Core/Controls/Kanban/Templates/Default/DefaultCardName'] = DefaultCardNameTemplate;
ko.templates['Core/Controls/Kanban/Templates/Default/DefaultCardAlias'] = DefaultCardAliasTemplate;
ko.templates['Core/Controls/Kanban/Templates/Default/DesignCardAlias'] = DesignCardAliasTemplate;

ko.templates['Core/Controls/Kanban/Templates/Default/DesignCardInfo'] = DesignCardInfoTemplate;
ko.templates['Core/Controls/Kanban/Templates/Default/DefaultCardInfo'] = DefaultCardInfoTemplate;

ko.templates['Core/Controls/Kanban/Templates/Todo/TodoCardName'] = TodoCardNameTemplate;
ko.templates['Core/Controls/Kanban/Templates/Todo/TodoCardInfo'] = TodoCardInfoTemplate;

ko.templates['Core/Controls/Kanban/Templates/Todo/TodoCardAlias'] = TodoCardAliasTemplate;

ko.templates['Core/Controls/Kanban/Templates/Default/TimerInCard'] = TimerInCardTemplate;

const defaultImage = 'data:image/jpeg;base64,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';

function enhanceUserWithAvatar({user, avatarThumbnails}: { user: UserModel; avatarThumbnails: ThumbnailModel[] }) {
    const thumbnail = user.UserTypeName === UserTypes.Usergroup
        ? avatarThumbnails.find(thumbnail => thumbnail.Id === user.UserId)
        : avatarThumbnails.find(thumbnail => thumbnail.Id === user.ContactId);

    const thumbnailImage = thumbnail && thumbnail.Image;

    return {user, thumbnail: thumbnailImage || defaultImage};
}

interface KanbanCardParams {
    entityId: number;
    recordId: number;
    tags: TagModel[];
    priority: PriorityModel;
    users: UserModel[];
    isDisabled: boolean;
    avatarThumbnails: KnockoutObservable<ThumbnailModel[]>;
    priorities: KnockoutObservable<PriorityModel[]>;
    thumbnail: CardThumbnailModel;
    mailsCount: number;
    parentOrChildRecords: ParentOrChildRecordModel[],
    color: string;
    warnings: string[];
    withGreyBackground: boolean;
    withDateBadges: boolean;
    colorBar: boolean;
    onPriorityUpdateError: () => void;
    onMailClick: () => void;
    progressBar: boolean;
    isDesign: boolean;
    isTodo: boolean;
    memo: string;
    readOnly: boolean;
    isCalculatedViaCalcPriority: boolean;
    heightImage: any;
    alwaysShowDeadline: boolean;
    hideOwner: boolean;
    showTooltip: boolean;
    showAlias: boolean;
    timerControl?: Timer;
    activeTimer?: TimerModel;
    retiredTodoActionsNumber?: number;
    totalTodoActionsNumber?: number;
    newActiveTimer?: TimerModel;
    actionRecord?: ActionModel;
}

export class KanbanCard {
    private _entityId: number;
    private _recordId: number;
    _tags: TagModel[];
    private _priority: KnockoutObservable<PriorityModel>;
    _allUsersTooltip: string;
    _avatarThumbnails: KnockoutObservable<ThumbnailModel[]>;
    _priorities: KnockoutObservable<PriorityModel[]>;
    private _thumbnail: CardThumbnailModel;
    _mailsCount: number;
    _parentOrChildRecords: ParentOrChildRecordModel[];
    _color: string;
    _warnings: string[];
    _withGreyBackground: boolean;
    private _withDateBadges: boolean;
    private _colorBar: boolean;
    private _alwaysShowDeadline: boolean;
    private _hideOwner: boolean;
    private _onPriorityUpdateError: () => void;
    _onMailClick: () => void;
    private _progressBar: boolean;
    private _isDesign: boolean;
    private _isTodo: boolean;
    private _element: HTMLElement;
    _viewerImages: KnockoutObservable<{ Files: FileModel[] }>;
    _areAvatarsWrapped: KnockoutObservable<boolean>;
    _owner: KnockoutComputed<{ user: UserModel; thumbnail: string }>;
    _performers: KnockoutComputed<{ user: UserModel; thumbnail: string }[]>;
    _priorityColor: KnockoutComputed<string>;
    _priorityName: KnockoutComputed<string>;
    _borderColor: KnockoutComputed<string>;
    private _retiredTodoActionsNumber: number;
    private _totalTodoActionsNumber: number;
    private _memo: string;
    private _readOnly: boolean;
    private _isCalculatedViaCalcPriority: boolean;
    private _heightImage: any;
    private _tooltip: Tooltip;
    private _labels = LABELS;
    private _showTooltip: boolean;
    private _showAlias: boolean;
    private _isDisabled: boolean;
    private _notifier: Notifier;
    private _activeTimer: KnockoutObservable<TimerModel>;
    _timerControl: Timer;
    private _actionRecord: ActionModel;

    NewActiveTimer: TimerModel;

    constructor(params: KanbanCardParams & { element: HTMLElement }) {
        const {
            entityId,
            recordId,
            tags,
            priority,
            users,
            isDisabled,
            avatarThumbnails = ko.observable([]),
            priorities,
            thumbnail,
            mailsCount,
            parentOrChildRecords,
            color,
            warnings = [],
            withGreyBackground,
            withDateBadges = true,
            colorBar,
            onPriorityUpdateError,
            onMailClick,
            progressBar,
            element,
            memo,
            retiredTodoActionsNumber,
            totalTodoActionsNumber,
            readOnly,
            isCalculatedViaCalcPriority,
            heightImage,
            alwaysShowDeadline,
            hideOwner,
            isDesign,
            isTodo,
            showTooltip,
            showAlias,
            timerControl,
            activeTimer,
            newActiveTimer,
            actionRecord
        } = params;

        this._entityId = entityId;
        this._recordId = recordId;
        this._tags = tags;
        this._priority = ko.observable(priority);
        this._avatarThumbnails = avatarThumbnails;
        this._priorities = priorities;
        this._thumbnail = thumbnail;
        this._mailsCount = mailsCount;
        this._parentOrChildRecords = parentOrChildRecords;
        this._color = color;
        this._warnings = warnings;
        this._withGreyBackground = withGreyBackground;
        this._withDateBadges = withDateBadges;
        this._colorBar = colorBar;
        this._onPriorityUpdateError = onPriorityUpdateError;
        this._onMailClick = onMailClick;
        this._progressBar = progressBar;
        this._isDesign = isDesign;
        this._isTodo = isTodo;
        this._element = element;
        this._retiredTodoActionsNumber = retiredTodoActionsNumber || 0;
        this._totalTodoActionsNumber = totalTodoActionsNumber || 0;
        this._memo = memo;
        this._alwaysShowDeadline = alwaysShowDeadline;
        this._hideOwner = hideOwner;
        this._readOnly = readOnly;
        this._isCalculatedViaCalcPriority = isCalculatedViaCalcPriority;
        this._heightImage = heightImage;
        this._isDisabled = isDisabled;

        this._viewerImages = ko.observable();

        this._tooltip = null;
        this._showTooltip = showTooltip;
        this._showAlias = !!showAlias;

        this._notifier = new Notifier();

        this._activeTimer = ko.observable(null);
        this.NewActiveTimer = newActiveTimer;
        this._actionRecord = actionRecord;

        if (thumbnail) {
            const thumbnailFileModel = new FileModel();
            thumbnailFileModel.ImageData = thumbnail.Image;

            this._viewerImages({Files: [thumbnailFileModel]});
        }

        this._areAvatarsWrapped = ko.observable(true);

        const owner = users.find(user => user.IsOwner);
        const performers = _.without(users, owner);

        const allUsers = owner ? [owner, ...performers] : performers;
        this._allUsersTooltip = allUsers.map(user => user.UserName).join(', ');

        this._owner = ko.pureComputed(
            () => owner && enhanceUserWithAvatar({user: owner, avatarThumbnails: this._avatarThumbnails()})
        );

        this._performers = ko.pureComputed(() => {
            const shownPerformers = this._areAvatarsWrapped() ? performers.slice(0, 1) : performers;

            return shownPerformers.map(user => enhanceUserWithAvatar({
                user,
                avatarThumbnails: this._avatarThumbnails()
            }));
        });

        this._priorityColor = ko.pureComputed(() => {
            const priority = this._priority();

            if (!priority) {
                return undefined;
            }

            return priority.Color;
        });

        this._priorityName = ko.pureComputed(() => {
            const priority = this._priority();

            if (!priority) {
                return undefined;
            }

            return priority.TranslatedName || priority.Name;
        });

        this._borderColor = ko.pureComputed(() => {
            return this._color ? ColorConverter.ToHex(this._color) : this._priorityColor() || '#cccccc';
        });

        this._activeTimer(this.GetActiveTimer(activeTimer));

        this.SetTimerControlData(timerControl, this._activeTimer());
    }

    get Element(): HTMLElement {
        return this._element;
    }
    get EntityId(): number {
        return this._entityId;
    }

    get RecordId(): number {
        return this._recordId;
    }

    get IsParentOrChildRecords(): boolean {
        return this._parentOrChildRecords && this._parentOrChildRecords.length > 0
    }

    get IsTagContainer(): boolean {
        return this.IsPriority || this.IsWarning || this.IsTags;
    }

    get IsTags(): boolean {
        return !!this._tags.length;
    }

    get IsWarning(): boolean {
        return !!this._warnings.length;
    }

    get IsPriority(): boolean {
        return this._priority() && !!this._priorities().length;
    }

    get AllUsersTooltip(): string {
        return !this._readOnly && this._showTooltip ? this._areAvatarsWrapped() && this._allUsersTooltip : '';
    }

    GetUserNameTooltip(user: UserModel): string | boolean {
        return !this._readOnly && this._showTooltip ? !this._areAvatarsWrapped() && user.UserName : '';
    }

    GetParentOrChildRecordTemplate() {
        return $((ko as any).renderTemplateX(DefaultParentOrChildRecordTemplate, this));
    }

    GetParentOrChildRecordName(nameTranslation?: string, name?: string): string {
        return nameTranslation ? nameTranslation : (name ? name : '-');
    }

    GetParentOrChildRecordTypeName(typeNameTranslation?: string, typeName?: string): string {
        return typeNameTranslation ? typeNameTranslation : typeName;
    }

    GetTitle(IsChild: boolean, IsParent: boolean) {
        if(IsChild && IsParent) {
            return this._labels.ITSELF;
        }
        else if(IsChild) {
            return this._labels.CHILD;
        }
        else {
            return this._labels.PARENT;
        }
    }

    GetIcon(IsChild: boolean, IsParent: boolean) {
        if(IsChild && IsParent) {
            return 'fa-retweet';
        }
        else if(IsChild) {
            return 'fa-level-down';
        }
        else {
            return 'fa-level-up';
        }
    }

    MouseOver(typeText: string, recordModel: ParentOrChildRecordModel, evt: any){
        let currentEl = $(evt.currentTarget);

        if (Math.round(currentEl.prop('scrollWidth')) > Math.round(currentEl.outerWidth()) ){
            let recordName = recordModel.NameTranslation ? recordModel.NameTranslation : (recordModel.Name ? recordModel.Name : '-');
            let recordTypeName = recordModel.TypeNameTranslation ? recordModel.TypeNameTranslation : recordModel.TypeName;
            let isTypeName = (typeText === 'isTypeName');

            let typeNameTooltipOptions = {
                position: {x: 'left', y: 'center'},
                outside: 'x',
                zIndex: 500001
            },
                nameTooltipOptions = {
                position: {x: 'right', y: 'center'},
                outside: 'x',
                zIndex: 500001
            };

            this._tooltip = new Tooltip(evt.currentTarget,
                                        ko.unwrap(isTypeName ? recordTypeName : recordName),
                                isTypeName ? typeNameTooltipOptions : nameTooltipOptions);
            this._tooltip.Show(evt.currentTarget);
        }
    }

    MouseOut(data, evt: any){
        if (this._tooltip){
            this._tooltip.Destroy();
        }
    }

    async OpenRecord(record){
        BlockUI.Block();
        const screenManager = (await import('Core/ScreenManager/ScreenManager')).ScreenManager;

        await screenManager.GetScreenByScreenType(
            this._entityId,
            ScreenTypes.ConsultScreen,
            record.Id
        )
            .always(() => {
                BlockUI.Unblock();
            })
            .then((screen: any) => {
                screen.ShowInModal();

                if (screen.GetType() === ScreenTypes[ScreenTypes.ConsultScreen]) {
                    PathRunner.Instance.GetUnit(screen.GetEntityId(), screen.IsSpecialScreenExist).LoadNewData(screen.GetRecordId());
                }
            })
            .fail(err => this._notifier.Failed(err.message));
    }

    GetNameTemplate() {
        if (this._isDesign) {
            return 'Core/Controls/Kanban/Templates/Default/DesignCardName';
        } else if (this._isTodo) {
            return 'Core/Controls/Kanban/Templates/Todo/TodoCardName';
        } else {
            return 'Core/Controls/Kanban/Templates/Default/DefaultCardName';
        }
    }

    GetAliasTemplate() {
        if (this._isDesign) {
            return 'Core/Controls/Kanban/Templates/Default/DesignCardAlias';
        } else if (this._isTodo) {
            return 'Core/Controls/Kanban/Templates/Todo/TodoCardAlias';
        } else {
            return 'Core/Controls/Kanban/Templates/Default/DefaultCardAlias';
        }
    }

    GetInfoTemplate() {
        if (this._isDesign) {
            return 'Core/Controls/Kanban/Templates/Default/DesignCardInfo';
        } else if (this._isTodo) {
            return 'Core/Controls/Kanban/Templates/Todo/TodoCardInfo';
        } else {
            return 'Core/Controls/Kanban/Templates/Default/DefaultCardInfo';
        }
    }

    GetTimerInCardTemplate(): string {
        return 'Core/Controls/Kanban/Templates/Default/TimerInCard';
    }

    GetHeightImage(): string {
        if (this._heightImage) {
            let elementWidth = Math.trunc($(this._element).outerWidth()),
                propertyHeight = this._heightImage.Value,
                originalCardWidth = $(this._element).data("originalCardWidth");

            if (originalCardWidth){
                return `${Math.trunc(originalCardWidth / 100 * propertyHeight)}px`;
            } else {
                $(this._element).data("originalCardWidth", elementWidth);
                return `${Math.trunc(elementWidth / 100 * propertyHeight)}px`;
            }

        } else {
            return "none";
        }
    }

    CalculateProgressBar() {
        let calculateProgressBar = this._retiredTodoActionsNumber / this._totalTodoActionsNumber;

        if (this._retiredTodoActionsNumber === this._totalTodoActionsNumber) {
            return 100;
        } else {
            return Math.trunc(calculateProgressBar * 100);
        }
    }

    get ProgressBar() {
        return `
            <div class="progress-bar" role="progressbar" 
                style="width: ${this.CalculateProgressBar()}%" 
                aria-valuenow="${this._retiredTodoActionsNumber}" 
                aria-valuemin="0" 
                aria-valuemax="${this._totalTodoActionsNumber}"></div>
        `;
    }

    GetOriginalImage(file: FileModel, viewer) {
        if (file.OriginalImageData) {
            viewer.clickOnImage(file.UniqueId);
            return;
        }

        const thumbnailElement = this._element.querySelector<HTMLAnchorElement>('.image-open-btn');

        BlockUI.Block({Target: thumbnailElement});

        ImageDataStore.GetOriginal({
            RecordId: this._recordId,
            FieldId: this._thumbnail.FieldId
        })
            .then(attachment => {
                file.OriginalImageData = attachment.Base64Data;
                this._viewerImages.valueHasMutated();
                viewer.clickOnImage(file.UniqueId);
            })
            .fail(err => this._notifier.Failed(err.message))
            .always(() => {
                BlockUI.Unblock(thumbnailElement);
            });
    }

    OnPriorityClick() {
        const currentPriority = this._priority();
        const priorities = this._priorities();

        const priorityIndex = priorities.findIndex(priority => priority.Id === currentPriority.Id);

        this._priority(priorities[priorityIndex === 0 ? priorities.length - 1 : priorityIndex - 1]);

        this.DebouncedUpdatePriority();
    }

    OnAvatarsClick() {
        this._areAvatarsWrapped(!this._areAvatarsWrapped());
    }

    private DebouncedUpdatePriority = _.debounce(this.UpdatePriority, 1000);

    UpdatePriority() {
        if (!this._entityId || !this._recordId) {
            return;
        }

        KanbanStore.UpdatePriority({
            EntityId: this._entityId,
            RecordId: this._recordId,
            PriorityId: this._priority().Id
        })
            .then(() => {
                this._notifier.Success(NOTIFICATIONS.RECORD_UPDATED);
            })
            .fail(err => {
                this._notifier.Failed(JSON.parse(err.message).Message);

                this._onPriorityUpdateError();
            });
    }

    GetActionDate(action: ActionModel) {
        return action.ActionDate && moment(`${action.ActionDate}Z`);
    }

    GetActionDateFormatted(action: ActionModel) {
        return this.GetActionDate(action).format('DD MMM YY')
    }

    GetActionDeadline(action: ActionModel) {
        return action.ActionDeadline && moment(`${action.ActionDeadline}Z`);
    }

    GetActionDeadlineFormatted(action: ActionModel) {
        return this.GetActionDeadline(action).format('DD MMM YY')
    }

    IsActionDateShown(action: ActionModel) {
        const actionDate = this.GetActionDate(action);
        const actionDeadline = this.GetActionDeadline(action);
        return Boolean(actionDate && (!actionDeadline || moment().isBefore(actionDate)));
    }

    UseBadgeTemplate(action: ActionModel) {
        const actionDate = this.GetActionDate(action);
        const actionDeadline = this.GetActionDeadline(action);
        const isActionDateShown = Boolean(actionDate && (!actionDeadline || moment().isBefore(actionDate)));

        return !(!this._withDateBadges || (!isActionDateShown && !actionDeadline));
    }

    get HasTimer(): boolean {
        return !!this._timerControl;
    }

    GetActiveTimer(activeTimer: TimerModel): TimerModel {
        return this.NewActiveTimer || activeTimer || null;
    }

    SetTimerControlData(timerControl, activeTimer)
    {
        if (!timerControl || !this._entityId || !this._recordId)
        {
            return null;
        }

        this._timerControl = timerControl.Clone() as Timer;
        this._timerControl.KanbanMode = true;
        this._timerControl.TimerEntityId = this._entityId;
        this._timerControl.TimerRecordId = this._recordId;
        this._timerControl.ActionRecord = this._actionRecord;

        if (activeTimer) {
            this._timerControl.CurrentDuration = activeTimer.Starting;
            this._timerControl.SetKanbanActiveTimer(activeTimer);
        }
    }

    AfterRender(el: Array<HTMLElement>){

    }

    GetTagFullNameTooltipContent(val1, val2, val3): string {
        let settings = {
            content: ''
        }
        settings.content = 'test'
        return 'test';
    }
    GetKanbanCardTemplateName(): string {
        return 'Core/Controls/Kanban/Templates/KanbanCard';
    }
}

ko.components.register('kanban-card', {
    viewModel: {
        createViewModel: (params: KanbanCardParams, componentInfo) =>
            new KanbanCard({...params, element: componentInfo.element as HTMLElement})
    },
    template: `<div class="js-kanban-card__component" data-bind="template: { name: GetKanbanCardTemplateName.bind($data), afterRender: $data.AfterRender.bind($data) }"></div>`
});